var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"custom-label",staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.labelDesc))]),_vm._v(" "),_c('div',{staticClass:"form",staticStyle:{"display":"inline-flex","width":"100%"}},[_c('color-picker-component',{ref:"colorPicker"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0768f1cd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/resources/BoxColor.vue
// module id = null
// module chunks = 